import { createContainer, createHook, createStore } from "react-sweet-state";

import {
    PricingPeriod,
    FormattedPriceCalculationResponse,
    CurrencyISOCode,
    PriceFinderMessages
} from "../constants";

import * as actions from "./actions";

export type PriceFinderState = {
    unitCount: number;
    billingCycle: PricingPeriod;
    priceCalcs: FormattedPriceCalculationResponse[];
    exampleMonthlyUnitCount: number;
    exampleAnnualUnitCount: number;
    currencyISOCode: CurrencyISOCode;
    showFirstFlatRateTier: boolean;
    messages: PriceFinderMessages;
};

export const initialState: PriceFinderState = {
    unitCount: 0,
    billingCycle: "MONTHLY",
    priceCalcs: [],
    exampleMonthlyUnitCount: 0,
    exampleAnnualUnitCount: 0,
    currencyISOCode: "USD",
    showFirstFlatRateTier: false,
    messages: {
        // These messages always be overridden by the consumer on init
        unitCountInputText: {},
        unitCountInputTooltip: {},
        monthlyExampleHelpText: {},
        annualExampleHelpText: {},
        exampleStandardPlan: {},
        monthlyExampleUnitCountText: {},
        monthlyExampleUnitCountAt: {},
        monthlyExampleUnitCountTotal: {},
        monthlyExampleEstimatedPrice: {},
        annualExampleUnitCountTierText: {},
        annualExampleEstimatedPrice: {},
        cardOverSignupLimit: {},
        cardEnterpriseMinimumCount: {},
        cardUnitCountTierRange: {},
        cardMonthlyPerUnitCount: {},
        cardFreeDescription: {},
        freeLimitModalTitle: {},
        freeLimitModalMessage: {}
    }
};

export const PriceFinderContainer = createContainer<PriceFinderState>();

const store = createStore({
    containedBy: PriceFinderContainer,
    name: "price-finder",
    initialState,
    actions,
    handlers: {
        onInit:
            () =>
            ({ setState }, state: PriceFinderState) => {
                setState({ ...state });
            }
    }
});

export const usePriceFinderStore = createHook(store);
